import { render, staticRenderFns } from "./EventsComponent.vue?vue&type=template&id=dd659800&scoped=true"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"
import style0 from "./EventsComponent.vue?vue&type=style&index=0&id=dd659800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd659800",
  null
  
)

export default component.exports